import {
  Pressable, Text, TextInput, View,
} from 'react-native';
import { useState } from 'react';
import Colors from '../../../constants/Colors';
import Style from '../../../constants/Style';
import isMobile from '../../../components/IsMobile';

interface ChatbotTextInputProps {
  // eslint-disable-next-line no-unused-vars
  handleSendMessage: (message: { message: string }) => void;
  disabled?: boolean;
  error?: string;
  placeholder?: string;
  sendingMessage?: boolean;
}

export const defaultProps: Partial<ChatbotTextInputProps> = {
  placeholder: 'Type your message here...',
  disabled: false,
  error: undefined,
  sendingMessage: false,
};

const ChatbotTextInput = ({
  handleSendMessage,
  sendingMessage,
}: ChatbotTextInputProps) => {
  const [message, setMessage] = useState<string>('');

  return (<View style={[Style.row, { padding: isMobile ? 12 : 20 }]}>
    <TextInput
          placeholder="Ask a question..."
          placeholderTextColor={Colors.light.hereworksBlack400}
          style={{
            flex: 1,
            backgroundColor: 'white',
            borderWidth: 1,
            padding: 12,
            borderColor: '#E0E0E0',
            borderRadius: 8,
          }}
          value={message}
          onChangeText={setMessage}
          returnKeyType='send'
          submitBehavior='blurAndSubmit'
          onSubmitEditing={() => {
            handleSendMessage({ message });
            setMessage('');
          }}
        />
        <Pressable
          style={{
            backgroundColor: Colors.light.hereworksBlue500,
            opacity: sendingMessage || message.trim() === '' ? 0.5 : 1,
            borderRadius: 8,
            padding: 12,
            marginLeft: 12,
            alignSelf: 'center',
          }}
          disabled={sendingMessage || message.trim() === ''}
          onPress={() => {
            handleSendMessage({ message });
            setMessage('');
          }}
        >
          <Text style={{
            color: 'white',
            fontFamily: 'Poppins_500Medium',
            textAlign: 'center',
          }}>Send</Text>
        </Pressable>
        </View>);
};

export default ChatbotTextInput;
